<script>
  import CardSingle from './CardSingle.svelte';
  import CardMultiple from './CardMultiple.svelte';
  export let data = {
    id: 'unknown',
  };
</script>

<div id="card-{data.id}" class="card">
  <h3>{data.title}</h3>
  <div class="description">{@html data.description}</div>
  {#if data.subs === 1}
    <div class="card--single--query">
      <CardSingle data={data.data[0]} />
    </div>
  {:else}
    <div class="card--multiple--query">
      <CardMultiple data={data.data} />
    </div>
  {/if}
</div>

<style>
  .card {
    background: var(--lightest);
    border-radius: 10px;
    flex: 0 0 100%;
    margin-right: 40px;
    max-width: 100%;
    padding: 0 20px 20px 20px;
    position: relative;
  }

  .card:last-child {
    margin-right: 0;
  }

  .card h3 {
    background: var(--lightest);
    border-radius: 10px 10px 0 0;
    margin: 0;
    padding: 20px 0;
    position: sticky;
    top: 0;
    z-index: 9;
  }

  .card--single--query,
  .card--multiple--query {
    display: block;
    height: auto;
    position: relative;
    width: 100%;
  }

  @media screen and (min-width:1024px) {

    .card h3 {
      position: relative;
    }
  }
</style>
